import { FC } from 'react';
// import Button from 'v3/common/components/Button';
// import PortalToTarget from 'v3/common/components/PortalToTarget';

const Aliceblue: FC = () => {
  return (
    <div className="maintainer__container">
      <i className="fa-regular fa-circle-info" />
      <p>
        <strong>Aliceblue</strong> is under maintenance. Please try again later.
      </p>
    </div>
  );
};

export default Aliceblue;
